import { CONFIG } from 'config'
import { OpenAPI } from 'openapi'

export async function uploadImageCover(blob: Blob, softwareId: number) {
  const formData = new FormData()
  formData.append('file', blob)
  const url = new URL(`/api/software-admin/software/${softwareId}/upload-cover-file/`, CONFIG.API_BASE_URL)

  return await fetch(url, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${OpenAPI.TOKEN}`,
    },
  })
}

export async function uploadBinary(blob: Blob, _softwareId: number) {
  const formData = new FormData()
  formData.append('file', blob)
  const url = new URL('//api/software-admin/upload-file/', CONFIG.API_BASE_URL)

  return await fetch(url, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${OpenAPI.TOKEN}`,
    },
  })
}
